<template>
  <div>
    <div
      class="mk-button mk-glass-object"
      :style="{width:`${object.width * 50 > 75 ? object.width * 50 : 75}px`}"
      @click="clickCallback"
    >
      <div>{{object.title}}</div>
      <div>{{valueInMetric}}{{metric ? 'mm' : '\"'}}</div>
      <div
        v-if="object.cutout"
        class="mk-glass-object__cutout"
      />
    </div>
  </div>
</template>

<script>
/**
 * Selection Glass Object
 * @author David <david.prenninger@gmx.de>
 *
 * This component represents a Glass as part of the configuration.
 * It shows title and values and runs a callback when clicked.
 */
export default {
  props: {
    object: Object,
    clickCallback: Function,
  },
  computed: {
    metric() {
      return this.$store.getters.metric;
    },
    valueInMetric() {
      if (this.metric) {
        return Math.floor(this.object.width * 500);
      }
      return Number(((this.object.width * 500) / 25.4).toFixed(1));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-glass-object {
  position: relative;
  height: 100px;
  color: $c_white;
  display: flex;
  align-items: center;
  padding-top: 10px;
  box-sizing: border-box;
  background-color: $c_glass;
  margin: 5px;
  display: flex;
  flex-direction: column;
  font-size: 14px;

  &__cutout {
    position: absolute;
    width: 30px;
    bottom: -5px;
    left: calc( 50% - 15px);
    height: 25px;
    background-color: $c_white;
    border-radius: $br_md;
  }
}
</style>
